import { Operator } from 'model/operator';
import { post, get, put } from 'store/request';

export const fetchOperatorList = async () => {
  const data = await get('/agency/operator/get_operator_list');
  return {
    list: data,
  };
};

export const addOperator = (params: Operator) => post('/agency/operator/add_operator', params);

export const updateOperator = (params: Operator) => put('/agency/operator/update_operator', params);

export const deleteOperator = (params: Operator) => post('/agency/operator/delete_operator', params);
